import {
  FETCH_SINGLE_PAGE_START,
  FETCH_SINGLE_PAGE_SUCCESS,
  FETCH_SINGLE_PAGE_FAILURE,
  FETCH_SITE_WORKING_CONTENT_START,
  FETCH_SITE_WORKING_CONTENT_FAILURE,
  FETCH_SITE_WORKING_CONTENT_SUCCESS,
} from "../actions/ActionConstant";

const initialState = {
  pageData: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  howItWorksPageData: {
    data: {},
    loading: true,
    error: false,
  },
};

const PageReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SINGLE_PAGE_START:
      return {
        ...state,
        pageData: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
        },
      };
    case FETCH_SINGLE_PAGE_SUCCESS:
      return {
        ...state,
        pageData: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case FETCH_SINGLE_PAGE_FAILURE:
      return {
        ...state,
        pageData: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
        },
      };
    case FETCH_SITE_WORKING_CONTENT_START:
      return {
        ...state,
        howItWorksPageData: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_SITE_WORKING_CONTENT_SUCCESS:
      return {
        ...state,
        howItWorksPageData: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_SITE_WORKING_CONTENT_FAILURE:
      return {
        ...state,
        howItWorksPageData: {
          data: {},
          loading: true,
          error: action.error,
        },
      };

    default:
      return state;
  }
};

export default PageReducer;
